export const CLASSNAME = "ScrollModal";
export const CLASSNAME_PREFIX = `${CLASSNAME}__`;
